<template>
  <el-form :model="keyWordsForm" ref="keyWordsForm" label-width="120px" class="demo-dynamic" label-position="top">
      <div class="keywords-title">Фильтры для вывода</div> 
      <span class="keyword-tool">Для точного совпадения со склонениями введите 0 для всех фильтров, для неточного число больше нуля(1-5). При значение -1 - полная выдача.</span>
    <div class="keywords-list-wrap" v-if="isEnabledKeyWords" v-bar>
      <div class="keywords-list">
        <template v-for="(item, index) in keyWordsForm.keywords">
          <el-form-item
            :prop="'keywords.' + index + '.value'"
            :key="index"
            v-if="item.enabled"
            class="keywords-list__item"
          >
          <label>
            <span>Фильтр</span>
            <el-input v-model="item.keyword" :placeholder="$t('feed.settings.keys.placeholder')">
              <i slot="suffix" class="el-input__icon el-icon-delete-solid el-icon-cursor" @click="deleteKeyWord(index)"></i>
            </el-input>
          </label>
            <label class="keywords-list__approx">
              <span>Расстояние</span>
              <el-select filterable v-model="item.approximation" slot="append">
                <el-option
                  v-for="item in options"
                  :label="item.value"
                  :value="item.value"
                  :key="item.value"
                ></el-option>
              </el-select>
            </label>
          </el-form-item>
        </template>
      </div>
    </div>
    <div class="keywords-list-un-enabled" v-else>
      {{$t('feed.settings.keys.empty')}}
    </div>
    <el-form-item>
      <el-button @click="addKeyWord">+ {{$t('feed.settings.keys.button')}}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    name: 'Keys',
    data() {
      return {
        options : [
          {
            value: '-1',
          },
          {
            value: '0',
          },
          {
            value: '1',
          },
          {
            value: '2',
          },
          {
            value: '3',
          },
                {
            value: '4',
          },
          {
            value: '5',
          },
        ],
      };
    },
    props: {
      keywords: {
        type: Array
      }
    },
    computed: {
      isEnabledKeyWords() {
        return this.keyWordsForm.keywords.filter(item => item.enabled).length;
      },
      keyWordsForm: {
        get() {
          if (!this.keywords.length) {
            this.$emit('addKeyWord');
          }

          return {
            keywords: this.keywords.slice()
          };
        },
      }
    },
    methods: {
      deleteKeyWord(index) {
        this.$emit('deleteKeyWord', index);
      },
      addKeyWord() {
        this.$emit('addKeyWord');
      }
    },
  };
</script>

<style>
  .keywords-list-wrap {
    position: relative;
    max-height: 270px;
    margin-bottom: 15px;
    /*margin-top: 15px;*/
    margin-right: 30px;
    overflow-y: auto!important;
    /*scrollbar-width: thin;*/
    scrollbar-color: rgb(103, 163, 227) rgb(229, 229, 226);
  }

  .keywords-list-wrap::-webkit-scrollbar {
  width: 12px;
}

.keywords-list-wrap::-webkit-scrollbar-track {
  background: rgb(229, 229, 226);
}

.keywords-list-wrap::-webkit-scrollbar-thumb {
  background-color: rgb(103, 163, 227);
  border-radius: 20px;
  border: 3px solid rgb(229, 229, 226);
}

  .keywords-list-wrap .el-form-item__content{
      display: flex;
      gap: 10px;
  }

  .keywords-list__approx{
    width: 100px;
  }

  .keywords-list__approx .el-input__inner{
    padding-right: 0;
  }

  .el-tooltip__popper.is-dark {
    background: #303133;
    color: #FFF;
    width: 250px;
}
    .keywords-list-wrap .el-form-item {
    display: inline-block;
    margin-bottom: 0;
    margin-top: 15px;
  }

  .keywords-list-wrap .el-form-item:nth-child(1),
  .keywords-list-wrap .el-form-item:nth-child(2),
  .keywords-list-wrap .el-form-item:nth-child(3) {
    margin-top: 0;
  }
  .keywords-title {
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 15px;
    width: fit-content;
  }
  .keyword-tool{
    font-size: 12px;
    line-height: 23px;
    color: red;
    display: block;
  }
  .keywords-list-un-enabled {
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 48px;
    color: #5E6D82;
  }
  .keywords-list {
    display: flex;
    flex-wrap: wrap;
  }
  .keywords-list__item {
    margin-right: 15px;
  }
  .el-icon-cursor {
    cursor: pointer;
  }
</style>
